import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon/Icon'
import Button from '../Button/Button'
import './Alert.scss'

const Alert = ({
  children,
  type = 'information',
  className = '',
  buttonAction,
  buttonLink,
  buttonLabel,
}) => {
  const alertClassList = `Alert -${type} ${className}`

  return (
    <div className={alertClassList}>
      <Icon name={type} className="Alert__icon" />
      <div className="Alert__content">{children}</div>
      {(buttonAction || buttonLink) && buttonLabel && (
        <Button onClick={buttonAction} link={buttonLink} type="secondary">
          {buttonLabel}
        </Button>
      )}
    </div>
  )
}

Alert.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  type: PropTypes.string,
  className: PropTypes.string,
  buttonAction: PropTypes.func,
  buttonLink: PropTypes.string,
  buttonLabel: PropTypes.string,
}

export default Alert
